/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/

import '../styles/style.scss';

/* ----------------------------------------------
Import and assign modules as global variables
---------------------------------------------- */

import * as Meteora from 'meteora';
import Classy from '@meteora-digital/classy';
import ModalController from '@meteora-digital/modal';
import TweenController from '@meteora-digital/tween';
import { tns } from "tiny-slider/src/tiny-slider";
window.Classy = Classy;
window.Meteora = Meteora;
window.TweenController = TweenController;
window.ModalController = ModalController;
window.tns = tns;

/*------------------------------------------------------------------
Add conditional scripts to the ScriptLoader object below
------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', function () {
  // Add the src and a condition required to load the script
  window.ScriptLoader = ScriptLoader({
    './components/global': true,
    './elements/header': document.querySelector('.js-header'),
    './elements/mobile-menu': document.querySelector('.js-mobile-menu'),
    './elements/search': document.querySelector('.js-search'),
    './components/breakpoints': document.querySelector('[data-breakpoint]'),
    './components/parallax': document.querySelector('[data-parallax]'),
    './components/equalizer': document.querySelector('[data-equalize-watch]'),
    './elements/videos': document.querySelector('[data-video]'),
    './elements/video-modals': document.querySelector('[data-video-modal]'),
    './elements/banner': document.querySelector('.js-banner'),
    './elements/forms': document.querySelector('form.userform'),
    './blocks/default/accordion': document.querySelector('.js-default-accordion'),
    './blocks/default/tabs': document.querySelector('.js-default-tabs'),
    './blocks/default/slider': document.querySelector('.js-default-slider'),
    './blocks/default/gallery': document.querySelector('.js-default-gallery')
  });
});

/*------------------------------------------------------------------
Script Loader
------------------------------------------------------------------*/

function ScriptLoader() {
  var imports = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // An array of the import object keys
  var scripts = Object.keys(imports);
  // For debugging purposes only
  var components = [];
  var load = function load() {
    var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
    // Make sure we have a script to import
    if (i >= scripts.length) {
      // Once everything has loaded, fire a 'scripts-loaded' event 
      setTimeout(function () {
        return window.dispatchEvent(new Event('scripts-loaded'));
      }, 500);
      return;
    }
    ;

    // Increment the index
    i += 1;

    // If this script is not needed, continue to the next script;
    if (!imports[scripts[i]]) {
      load(i);
      return;
    }
    ;

    // Otherwise continue on to load the script
    import("".concat(scripts[i])).then(function () {
      return components.push(scripts[i]);
    })["catch"](function (error) {
      return console.warn(error);
    })["finally"](function () {
      return load(i);
    });
  };
  load();
  return components;
}
window.addEventListener('scripts-loaded', function () {
  console.log("%cmarmalade", "color:#0c0c0d; font-family: monospace; font-size: 20px; padding: 5px 10px; border-radius: 5px; background-color: #bbb");
  document.body.classList.add('scripts-loaded');
  window.ScrollLocker.unlock();
});